import {match} from 'ts-pattern';

import {sum} from 'ramda';

import type {NewModelDraft} from './newModelDraft';

type RemovableCollection = 'engines' | 'trims' | 'colours' | 'upholsteries';

// Mirrors what removeDraftRecord deletes or unlinks, so the confirmation count never drifts from it.
export function buildRemovalWarning(
  draft: NewModelDraft,
  collection: RemovableCollection,
  id: string
) {
  return match(collection)
    .with('engines', () => {
      const counts = {variants: draft.variants.filter((row) => row.engineId === id).length};
      return {kind: 'engines' as const, counts, count: sum(Object.values(counts))};
    })
    .with('trims', () => {
      const counts = {
        variants: draft.variants.filter((row) => row.trimId === id).length,
        colours: draft.colours.filter((row) => row.trimIds.includes(id)).length,
        upholsteries: draft.upholsteries.filter((row) => row.trimIds.includes(id)).length,
        equipment: draft.attachments.filter((row) => row.trimId === id).length,
        packages: draft.packages.filter((row) => row.applicableTrimIds.includes(id)).length,
      };
      return {kind: 'trims' as const, counts, count: sum(Object.values(counts))};
    })
    .with('colours', 'upholsteries', (kind) => {
      const counts = {
        trims: draft[kind].find((row) => row.id === id)?.trimIds.length ?? 0,
        restrictions: draft.restrictions.filter((row) =>
          kind === 'colours' ? row.colourId === id : row.upholsteryId === id
        ).length,
      };
      return {kind: 'trimLinked' as const, counts, count: sum(Object.values(counts))};
    })
    .exhaustive();
}
